<template>
  <el-dialog
    v-model="dialogVisible"
    width="560px"
    destroy-on-close
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="closeOnEscape"
    :show-close="showClose"
    title="提示"
    data-testid="update-notice-dialog"
    @close="handleClose"
  >
    <div v-if="props.mode === 'before' && !isForceUpdate" class="text-size-18px fw-600">
      {{ `检测到新版本，请刷新以更新到最新版本${newestVersion?.systemVersion?.systemVersion}` }}
    </div>
    <div v-else-if="props.mode === 'after'" class="text-size-18px fw-600">
      {{ `${newestVersion?.systemVersion?.systemVersion || '最新版本'}已更新完成` }}
    </div>

    <div v-if="newestVersion?.systemVersion">
      <div v-html="renderMarkdown(newestVersion.systemVersion.noticeContent ?? '')" />
    </div>

    <template #footer>
      <div class="flex justify-center">
        <el-button @click="handleConfirm" type="primary" data-testid="update-notice-confirm-button" style="width: 325px; height: 46px;background: linear-gradient(180deg, #1E6CEB 0%, #1155C5 100%);border-radius: 4px;box-shadow: 2px 2px 8px 0 rgb(0 82 217 / 25%);">{{ buttonText }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
import { useVModel } from "@vueuse/core"
import { ElButton, ElDialog } from "element-plus"
import { marked } from "marked"
import { computed } from "vue"
import { useAppStore } from "@/store/modules/app"
import { getNewestVersion, removeUpdateNoticeNeedShow } from "@/utils/cache/localStorage"

const emit = defineEmits(["update:modelValue", "confirm", "cancel"])

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * 使用场景：before-更新前提示，after-更新完成提示
   */
  mode: {
    type: String as () => 'before' | 'after',
    default: 'before',
  },
})

const appStore = useAppStore()
const dialogVisible = useVModel(props, "modelValue", emit, { passive: true })

// 从store中获取最新版本信息
const newestVersion = computed(() => getNewestVersion())
// 根据mode和noticeType判断是否为强制更新（仅before模式下生效）
const isForceUpdate = computed(() => props.mode === 'before' && newestVersion.value?.systemVersion?.noticeType === 2)

// 按钮文本
const buttonText = computed(() => {
  if (props.mode === 'after') return '关闭'
  return isForceUpdate.value ? '立即更新' : '我知道了'
})
const closeOnEscape = computed(() => props.mode === 'after' || !isForceUpdate.value)
const showClose = computed(() => props.mode === 'after' || !isForceUpdate.value)

const renderMarkdown = (text: string) => {
  return marked(text)
}

const handleConfirm = () => {
  if (props.mode === 'after') {
    handleClose()
    return
  }
  if (isForceUpdate.value) {
    if (newestVersion.value) {
      appStore.setCurrentSystemVersion(newestVersion.value)
      handleClose()
      window.location.reload()
    }
  } else {
    handleClose()
  }
}

const handleClose = () => {
  // 当对话框被关闭时（通过ESC键或其他方式），同步更新store状态
  dialogVisible.value = false
  appStore.setShowUpdateNoticeDialog(false)
  removeUpdateNoticeNeedShow()
}
</script>
